import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { NoProvidersIllustration } from '../../images';
import { emptyStateContainerStyles } from './styles';

export const NoEventsMessage = () => {
  const { t } = useTranslation('schedule');

  return (
    <section css={emptyStateContainerStyles}>
      <NoProvidersIllustration />
      <Text color='light' textAlign='center'>
        {t('Your calendar is looking a bit empty!')}
      </Text>
    </section>
  );
};
